export default () => ({
  category: null,
  string: '',
  data: {},
  autocompleteSource: null,
  searchParams: {
    limit: 50,
    offset: 0,
  },
});
